module.exports = __webpack_public_path__ + "static/media/laptop_active.9e2ab851.png";